<div class="img-container d-flex flex-wrap justify-content-end mt-4">
  <div class="img-container_add" *ngIf="imageList.length < length">
    <button (click)="fileInput.click()" class="btn-add"></button>
  </div>

  <input
    type="file"
    multiple
    accept="image/png, image/jpeg, image/jpg"
    class="d-none"
    (change)="onFileInput($event?.target?.files)"
    #fileInput
  />

  <div
    *ngFor="let img of imageList || []; let i = index"
    class="img-container_item"
  >
    <div class="img-wrapper">
      <img [src]="img" alt="uploaded image" />
      <button class="remove" (click)="removeImg(i)" title="حذف الصورة">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>
</div>

<div class="warning" *ngIf="images.length < 3">
  <span class="text-right text-warning">يجب تحميل 3 صور</span>
</div>

<div class="warning" *ngIf="showLengthWarning">
  <span class="text-right text-warning">لا يمكن تحميل أكثر من {{ length }} صور</span>
</div>
